import { connect } from 'react-redux';

import { compose, withProps, renderNothing, branch, withState, withHandlers, lifecycle } from 'recompose';
import {
  canUserModifyBarbers,
} from '../../../../../common/helpers/users';
import { getShops, isBrandViewActive } from '../../../../../auth/selectors';
import {
  handleSelectLocation,
  handleDeselectLocation,
  handleLocationDrop,
  handleSelectAll,
  handleDeselectAll,
  mapShopsToLocationOptions,
} from './utils';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';

const LocationsContainer = compose(
  connect(state => ({
    isBrandView: isBrandViewActive(state),
    permissions: state.auth.permissions,
    shops: getShops(state),
  })),
  withProps(
    props => ({
      canModify: canUserModifyBarbers(props.permissions),
      initiallySelectedLocations: Object.keys(props.formValues).filter(locationId => locationId !== LOCATIONS_ALL_ID),
    })
  ),
  withState(
    'availableLocations',
    'setAvailableLocations',
    props =>
      mapShopsToLocationOptions(props.shops.filter(shop => !props.initiallySelectedLocations.includes(shop.id))),
  ),
  // selectedLocations, setSelectedLocations is extracted to top level hocs to be able to use during submit
  withState('locationsFilter', 'setLocationsFilter', ''),
  withHandlers({
    onSelectLocation: props => locationId => () => handleSelectLocation(props, locationId),
    onDeselectLocation: props => locationId => () => handleDeselectLocation(props, locationId),
    onLocationDrop: props => result => handleLocationDrop(props, result),
    onSelectAll: props => () => handleSelectAll(props),
    onDeselectAll: props => () => handleDeselectAll(props),
  }),
  lifecycle({
    componentDidMount() {
      this.props.setSelectedLocations(
        mapShopsToLocationOptions(
          this.props.shops.filter(shop => this.props.initiallySelectedLocations.includes(shop.id))
        )
      );
    },
  }),
  branch(
    props => !props.isBrandView,
    renderNothing,
  ),
);

export default LocationsContainer;
